export function filterTeaserItems() {
    const teaserItemsBlock = document.querySelector(".pul-teaser-items-block");

    if (teaserItemsBlock) {
        const filterButtons = teaserItemsBlock.querySelectorAll(".pul-btn-tertiary");
        const teaserItems = teaserItemsBlock.querySelectorAll(".pul-teaser-item-card[data-country]");

        for (const filterButton of filterButtons) {
            filterButton.addEventListener("click", () => {
                // remove active class from all filters
                filterButton.closest(".pul-teaser-items-block__filters").querySelector(".active").classList.remove("active");

                // add active class
                filterButton.classList.add("active");

                // filter contacts based on the clicked filter
                const filter = filterButton.getAttribute("data-country");
                
                for (const teaserItem of teaserItems) {
                    if (teaserItem.dataset.country === filter) {
                        teaserItem.classList.remove("hidden");
                    } else {
                        teaserItem.classList.add("hidden");
                    }
                }
            })
        }
    }
}